import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './vant/vant'

import 'normalize.css' // 引入 normalize.css
import './assets/css/base.css' // 引入自定义基础样式
import './assets/css/animation.css'
import './assets/fonts/iconfont.css'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)

Vue.config.productionTip = false
Vue.prototype.formatTraffic = (trafficStr) => {
  // 提取数值和原始单位（如从"3072000.00MB"中获取3072000.00和"MB"）
  const [, valueStr, unit] = trafficStr.split(/^(\d+\.\d+)([A-Za-z]+)$/); // 按字母分割数值和单位
  const value = parseFloat(valueStr);

  // 校验输入合法性
  if (isNaN(value) || unit !== 'MB') {
    console.error('无效输入')
    return '--';
  }

  // 1GB = 1024MB，判断是否超过1G
  const gbValue = value / 1024;
  if (gbValue >= 1) {
    // 超过1G，保留两位小数，使用GB单位
    return `${gbValue.toFixed(2)}GB`;
  } else {
    // 未超过1G，保留两位小数，仍用MB单位
    return `${value.toFixed(2)}MB`;
  }
}

// 分=>元
Vue.prototype.fenToYuan = (num) => {
  if (typeof num === 'undefined') return '0.00'
  const parsedNumber = typeof num === 'string' ? parseFloat(num) : num
  return (parsedNumber / 100.0).toFixed(2)
}

// 只在开发环境或测试环境启用调试面板
const isDev = process.env.NODE_ENV === 'development'
const isProdDebug = location.href.includes('debug=true') // 也可以通过 URL 参数开启

if (isProdDebug) {
  import('vconsole').then(module => {
    const VConsole = module.default || module
    window.vConsole = new VConsole() // 挂载到 window 方便后续控制
    console.log('vConsole 已启动')
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
